import React from 'react';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton } from '@mui/material';
import Employee from '@/types/Employee.type';
import { Departments } from '@/types/Department.type';
import { Role } from '@/common/constants';

type Props = {
  onEdit: (id: number) => void;
  onDelete: (id: number, number: string) => void;
  rows: Array<Employee & Departments>;
};

const EmployeeTableBody: React.FC<Props> = ({ onEdit, onDelete, rows }) => {
  return (
    <TableBody>
      {rows.map((row) => (
        <TableRow key={row.id}>
          <TableCell>{row.name}</TableCell>
          <TableCell>{row.email}</TableCell>
          <TableCell>
            {row.departments.map((department, index) => (
              <React.Fragment key={index}>
                {department.name}
                <br />
              </React.Fragment>
            ))}
          </TableCell>
          <TableCell>
            {row.role === Role.管理者 && '管理者'}
            {row.role === Role.アナウンス && 'アナウンス'}
            {row.role === Role.一般 && '一般'}
          </TableCell>
          <TableCell>
            <IconButton onClick={() => onEdit(row.id)}>
              <EditIcon />
            </IconButton>
            <IconButton onClick={() => onDelete(row.id, row.name)}>
              <DeleteIcon />
            </IconButton>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
};
export default EmployeeTableBody;
